import React from "react";
import Icon, { IconName } from "@/components/ui/Icon";
import styles from "./styles.module.scss";

export type BadgeTone =
  | "success"
  | "warning"
  | "danger"
  | "neutral"
  | "primary"
  | "primarySoft"
  | "accent"
  | "accentSoft"
  | "subtle";

interface BadgeProps {
  tone?: BadgeTone;
  icon?: IconName;
  compact?: boolean;
  title?: string;
  className?: string;
  children: React.ReactNode;
}

const Badge: React.FC<BadgeProps> = ({
  tone = "neutral",
  icon,
  compact,
  title,
  className,
  children,
}) => (
  <span
    title={title}
    className={`${styles.badge} ${styles[tone]} ${compact ? styles.compact : ""} ${className ?? ""}`}
  >
    {icon && <Icon name={icon} size={compact ? 11 : 12} strokeWidth={2.6} />}
    {children}
  </span>
);

export default Badge;
